/*
 * The english translation of all compoinents that the Profile view folder needs.
 */
export const PROFILE_VIEW_EN = {
  // AppearanceLayout.vue
  colorPicker: 'Color Picker',
  primaryColor: 'Primary Color',
  backgroundColor: 'Background Color',
  // PromptDataTable.vue
  createPrompt: 'Create Prompt',
  // GamificationComponent.vue
  creations: 'Creations',
  languages: 'Languages',
  resetBoxLayout: 'Reset Box Layout',
  makeSureYouTypeInYourPassword: 'Make sure you type in your password',
  close: 'Close',
  saveChanges: 'Save Changes',
  yourOrganisation: 'Your Organisation: ',
  // LanguageSettingsView.vue & StyleSettingsView.vue
  remove: 'Remove',
  languageDescription: 'Language Description',
  enterLanguageDescription: 'Enter language description...'
}
/*
 * The german translation of all compoinents that the Profile view folder needs.
 */
export const PROFILE_VIEW_DE = {
  // AppearanceLayout.vue
  colorPicker: 'Farbauswahl',
  primaryColor: 'Primärfarbe',
  backgroundColor: 'Hintergrundfarbe',
  // PromptDataTable.vue
  createPrompt: 'Prompt erstellen',
  // GamificationComponent.vue
  creations: 'Inhalte',
  languages: 'Sprachen',
  resetBoxLayout: 'Box Layout zurücksetzten',
  makeSureYouTypeInYourPassword: 'Tippen Sie Ihr Passwort ein',
  close: 'Schließen',
  saveChanges: 'Änderungen speichern',
  yourOrganisation: 'Ihre Organisation: ',
  // LanguageSettingsView.vue & StyleSettingsView.vue
  remove: 'Entfernen',
  languageDescription: 'Sprachbeschreibung',
  enterLanguageDescription: 'Sprachbeschreibung eingeben...'
}
